<template>
    <transition name="slide-fade">
        <div class="dock-above">
            <div v-if="tree.length" @click="currentObject(item.id)" v-for="item in history" v-bind:key="item.id" v-bind:class="['dock-above-inner', isActive(item.id) ? 'dock-above-active': '']">
                <a class="dock-above-button">{{ getObjTree(item.id).obj.name }}</a>
            </div>
        </div>
    </transition>
</template>

<script>
import { mapGetters, mapActions, mapMutations } from 'vuex'
export default {
  name: 'Quick',
  computed: {
    ...mapGetters({
      tree: 'tree',
      getObjTree: 'getObjectFromTree',
      history: 'getHistory',
      getCD: 'getCurrentDevice',
      getCG: 'getCurrentGroup'
    }),
    isActive () {
      return (id) => !!this.tree[this.getCG].children[this.getCD] && this.tree[this.getCG].children[this.getCD].data.id === id
    }
  },
  methods: {
    ...mapMutations(['fitNewMarker']),
    ...mapActions({
      curObj: 'setCurrentDevice'
    }),
    currentObject (id) {
      const object = this.getObjTree(id)
      this.curObj({
        idx: object.idx,
        idxg: object.idxg,
        id: id,
        group_id: object.obj.group_id,
        noHistory: true
      }).then(this.fitNewMarker.bind(this, object.obj))
    }
  }
}
</script>

<style lang="scss" scoped>

</style>



// WEBPACK FOOTER //
// src/components/controls/Quick.vue